export default function PlaceholderPage({ title, intro }) {
  return (
    <div className="page">
      <section className="hero hero--compact">
        <div className="hero-inner">
          <p className="eyebrow">Recycla Chile</p>
          <h1>{title}</h1>
          <p className="hero-lead">{intro}</p>
        </div>
      </section>
      <section className="page-content">
        <div className="content-wrap">
          <article className="content-card">
            <p>Esta sección se migrará en el siguiente paso.</p>
          </article>
        </div>
      </section>
    </div>
  );
}
